
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veterans/jangji/[companyname]",
      function () {
        return require("private-next-pages/veterans/jangji/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veterans/jangji/[companyname]"])
      });
    }
  